import { render, staticRenderFns } from "./GuanYuWoMenView.vue?vue&type=template&id=10949b7b&scoped=true"
import script from "./GuanYuWoMenView.vue?vue&type=script&lang=js"
export * from "./GuanYuWoMenView.vue?vue&type=script&lang=js"
import style0 from "./GuanYuWoMenView.vue?vue&type=style&index=0&id=10949b7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10949b7b",
  null
  
)

export default component.exports